import React from 'react';

import { RenderNetworkError } from './RenderNetworkError';
import { RenderSuccess } from './RenderSuccess';
import { RenderError } from './RenderError';

function successCheck(data) {
  return (
    (data?.installed && data?.error?.name !== 'INCORRECT_TRACKING_SCRIPT_INSTALLED') ||
    (data?.installed && !data?.error?.name)
  );
}

export function RenderResult({
  data,
  error,
  originalUrl,
  origin,
  CardComponent,
  ui,
  successTitle,
  successDescription,
}) {
  if (error) {
    return <RenderNetworkError error={error} originalUrl={originalUrl} CardComponent={CardComponent} ui={ui} />;
  }

  if (!data || !originalUrl) {
    return null;
  }

  const installPath = !origin ? '/install' : origin.replace('/check-script', '');

  if (successCheck(data)) {
    return (
      <RenderSuccess
        data={data}
        originalUrl={originalUrl}
        finalUrl={data.finalUrl}
        installPath={installPath}
        CardComponent={CardComponent}
        ui={ui}
        successTitle={successTitle}
        successDescription={successDescription}
      />
    );
  }

  if (data?.error?.name) {
    return <RenderError data={data} installPath={installPath} CardComponent={CardComponent} ui={ui} />;
  }
}
